import { render, staticRenderFns } from "./my-checkbox.vue?vue&type=template&id=941e1ac6&scoped=true&"
import script from "./my-checkbox.vue?vue&type=script&lang=js&"
export * from "./my-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./my-checkbox.vue?vue&type=style&index=0&id=941e1ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941e1ac6",
  null
  
)

export default component.exports